import { Field, FieldProps, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import * as React from 'react'
import { IMobilityOptionObject } from '../../../types'
import { isNotBlank } from '../../../utils/validators'
import ErrorMessage from '../../ui/ErrorMessage'
import Checkbox from './Checkbox'
import Dropdown from './Dropdown'

export interface IFormValues {
  formError?: string
  category: string
  name: string
  ableToTS: boolean
  categories: any[]
}

interface IFormProps {
  onCancelClick: () => void
  categories: any[]
}

interface IAddMobilityOptionCreateFormProps {
  categories: any[]
  onCancelClick: () => void
  onCreateClick: (mobilityOption: IMobilityOptionObject) => Promise<any>
}

export const InnerForm = (props: IFormProps & FormikProps<IFormValues>): any => {
  const { touched, errors, isSubmitting, onCancelClick, handleSubmit, categories } = props

  const textInput = ({ field, form }: FieldProps<IFormValues>) => {
    return <input type='text' {...field} />
  }
  const defaultOption = categories[0]

  return (
    <Form onSubmit={handleSubmit}>
      <ErrorMessage visible={!!errors.formError} className='mt1'>
        Failed to create Mobility Device
      </ErrorMessage>

      {/* Category */}
      <div className='mt1'>
        <label className='font-small weight-300 font-grey3'>Category</label>
        <Dropdown name='category' options={categories} defaultOption={defaultOption} placeholder='Select Category' />
      </div>

      {/* Name */}
      <div className='mt2'>
        <label className='font-small weight-300 font-grey3'>Name*</label>
        <Field name='name' render={textInput} />
        {touched.name && errors.name && (
          <p className='ErrorMsgDivForName font-small weight-300 font-red'>{errors.name}</p>
        )}
      </div>

      {/* Able to transfer to seat */}
      <div className='mt2'>
        {/* This is unchecked by default */}
        <Checkbox name='ableToTS' value={false} displayName={'Able to transfer to a seat?'} />
      </div>

      {/* Buttons */}
      <div className='flex items-center justify-end mt3'>
        <button type='button' onClick={onCancelClick} className='CancelButton btn bg-white rounded font-light-grey mr2'>
          Cancel
        </button>

        <button
          type='submit'
          disabled={isSubmitting}
          className='SubmitButton btn bg-green rounded font-white weight-300'
        >
          Add
        </button>
      </div>
    </Form>
  )
}

export const AddMobilityOptionCreateForm = withFormik<IAddMobilityOptionCreateFormProps, IFormValues>({
  mapPropsToValues: (props: IAddMobilityOptionCreateFormProps): IFormValues => {
    return {
      category: props.categories[0] ? props.categories[0].value : null,
      name: '',
      ableToTS: false,
      categories: props.categories
    }
  },
  mapValuesToPayload: x => x,
  validate: (values: IFormValues): FormikErrors<IFormValues> => {
    const errors: FormikErrors<IFormValues> = {}
    if (!isNotBlank(values.name)) {
      errors.name = 'Name is required'
    }
    return errors
  },
  handleSubmit: (values: IFormValues, { props, setSubmitting, setFieldError }) => {
    props
      .onCreateClick({
        name: values.name,
        categoryId: values.category,
        isTransferableSeat: values.ableToTS,
        id: '0'
      })
      .then(result => {
        setSubmitting(false)
        props.onCancelClick()
      })
      .catch((error: string) => {
        setFieldError('formError', error)
        setSubmitting(false)
      })
  }
})(InnerForm)

export default AddMobilityOptionCreateForm



// WEBPACK FOOTER //
// ./src/components/mobility-options/AddMobilityOptionCreateForm/AddMobilityOptionCreateForm.tsx